import React from 'react'
// ##
import ViewCompany from '../../modules/Company/components/ViewCompany'

export default function CompanyPage() {
  return <ViewCompany />
}
